export class MxDatasetViewManagerController {
	static $inject = ['mx.shell.SearchProviderService', 'mx.shell.EventService', 'mx.SolutionBuilderAgent.EntityService', '$scope', '$q'];

	constructor(searchService, eventService, entityService, $scope, $q) {
		Object.assign(this, { searchService, eventService, entityService, $scope, $q });

		eventService.subscribeTo(
			mx.shell.EventCodes.Search,
			(event, searchOptions) => {
				if (searchOptions && (!searchOptions.searchForm.customFormConditions || searchOptions.searchForm.customFormConditions.length === 0)) {
					this.resetForm = true;
				}
			},
			$scope
		);
	}

	$onChanges(changes) {
		Object.keys(changes).forEach((propertyName) => {
			const handlerName = propertyName + 'ChangeHandler';
			if (typeof this[handlerName] === 'function') {
				this[handlerName](changes[propertyName].currentValue, changes[propertyName].previousValue);
			}
		});
	}

	async triggerDataReloadChangeHandler(reload) {
		if (reload && typeof this.mxSearchPageContentCtrl.onRefreshClick === 'function') {
			if (this.formConditions && Boolean(this.formConditions.length)) {
				const promises = [];
				const keys = Object.keys(this.formConditions);
				keys.forEach((key) => {
					if (this.formConditions[key].hasOwnProperty('referenceTo')) {
						promises.push(
							this.entityService.getEnumeration(this.formConditions[key].referenceTo).then((enumeration) => {
								const cond = this.formConditions[key];
								const _enum = _.find(enumeration.Values, { Value: cond.value });
								if (_enum) {
									cond.value = _enum.DisplayString;
								}
							})
						);
					}
				});

				await Promise.all(promises);
				// Adds configuration form conditions
				const currentSearch = this.searchService.currentSearch();

				if (!currentSearch.searchForm.hasOwnProperty('customFormConditions')) {
					currentSearch.searchForm.customFormConditions = this.formConditions;
				} else {
					currentSearch.searchForm.customFormConditions.length = 0;
					Array.prototype.push.apply(currentSearch.searchForm.customFormConditions, this.formConditions);
				}

				this.mxSearchPageContentCtrl.onRefreshClick();
			} else {
				// Reload search with new conditions
				this.mxSearchPageContentCtrl.onRefreshClick();
			}
		}
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxDatasetViewManager', {
	require: { mxSearchPageContentCtrl: '^mxSearchPageContent' },
	bindings: {
		triggerDataReload: '<',
		formConditions: '<?',
		resetForm: '=?',
	},
	template: '',
	controller: MxDatasetViewManagerController,
	controllerAs: 'vm',
});
